import { render, staticRenderFns } from "./CompanyRepxStagesMappingSetup.vue?vue&type=template&id=2e5baf34&scoped=true"
import script from "./CompanyRepxStagesMappingSetup.vue?vue&type=script&lang=js"
export * from "./CompanyRepxStagesMappingSetup.vue?vue&type=script&lang=js"
import style0 from "./CompanyRepxStagesMappingSetup.vue?vue&type=style&index=0&id=2e5baf34&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5baf34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5baf34')) {
      api.createRecord('2e5baf34', component.options)
    } else {
      api.reload('2e5baf34', component.options)
    }
    module.hot.accept("./CompanyRepxStagesMappingSetup.vue?vue&type=template&id=2e5baf34&scoped=true", function () {
      api.rerender('2e5baf34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/onboarding/CompanyRepxStagesMappingSetup.vue"
export default component.exports